// extracted by css-extract-rspack-plugin
export default {"breadCrumb":"breadCrumb__q4TtL","header":"header__i2lfo","drawer":"drawer__XamnA","body":"body__hhOSb","scroller":"scroller__P9PkC","scrollY":"scrollY__mlG1T"};